// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pi-c";
export var backButton = "_pi-4";
export var backIcon = "_pi-5";
export var chevronShortcut = "_pi-6";
export var container = "_pi-1";
export var editor = "_pi-8";
export var editorWrapper = "_pi-7";
export var prefix = "_pi-2";
export var searchIcon = "_pi-3";
export var suffix = "_pi-9";
export var suffixContent = "_pi-a";
export var suffixText = "_pi-b";
export var wrapper = "_pi-0";